import React from 'react';

function NodeInfo({ node, processInfo, formatUptime }) {
  if (!node || !processInfo) return null;
  const versions = node.versions || {};
  const cpuUsage = processInfo.cpuUsage || { user: 0, system: 0 };

  return (
    <div style={{ background: '#111827', border: '1px solid #374151', borderRadius: 12, padding: 16 }}>
      <h3 style={{ color: '#e5e7eb', marginTop: 0, marginBottom: 12, fontSize: 18 }}>Node.js</h3>
      <div style={{ display: 'grid', gap: 8 }}>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>Version</div>
          <div style={{ color: '#e5e7eb' }}>{node.version}</div>
        </div>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>V8</div>
          <div style={{ color: '#e5e7eb' }}>{versions.v8 || '—'}</div>
        </div>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>Process ID</div>
          <div style={{ color: '#e5e7eb' }}>{processInfo.pid}</div>
        </div>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>Uptime</div>
          <div style={{ color: '#e5e7eb' }}>{formatUptime(processInfo.uptime)}</div>
        </div>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>CPU Usage</div>
          <div style={{ color: '#e5e7eb' }}>{((Number(cpuUsage.user) + Number(cpuUsage.system)) / 1000000).toFixed(2)}ms</div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(NodeInfo);
